import { WbsInputListDto } from '@api/client';
import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { getWbsProjectPlanningById, saveWbsPlanning } from 'pages/private/_redux/planning/actions';
import { wbsDataTableSelector } from 'pages/private/_redux/planning/selectors';
import { AppToastService } from 'shared/design-system/components/app-toast/app-toast.service';

const useSaveWbs = () => {
  const dispatch = useAppDispatch();
  const deliverableData = useAppSelector(wbsDataTableSelector);

  const saveWbs = () => {
    if (!deliverableData) return;
    const payload: WbsInputListDto[] = deliverableData.map((item) => ({
      ...item,
      wbsPlanningInputDtoList: item.wbsPlanningDtoList || [],
    }));
    dispatch(saveWbsPlanning(payload))
      .unwrap()
      .then((res) => {
        if (res) {
          AppToastService.success('WBS saved successfully.');
          dispatch(getWbsProjectPlanningById(deliverableData[0].projectId!));
        }
      });
  };

  return { saveWbs };
};

export default useSaveWbs;
